import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

const STYLE = {
  pass: { icon: CheckCircle2, cls: 'bg-emerald-50 text-emerald-800 border-emerald-200', badge: 'PASS' },
  warn: { icon: AlertTriangle, cls: 'bg-amber-50 text-amber-800 border-amber-200', badge: 'WARN' },
  fail: { icon: XCircle, cls: 'bg-rose-50 text-rose-800 border-rose-200', badge: 'FAIL' },
};
const CATEGORY = { input: 'Input completeness', accounting: 'Accounting checks (every month, ±0.01)', assumption: 'Assumption warnings' };

export function StatusBadge({ status, testId }) {
  const s = STYLE[status] || STYLE.warn; const Icon = s.icon;
  return <span className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-[11px] font-semibold ${s.cls}`} data-testid={testId}><Icon size={12} aria-hidden />{s.badge}</span>;
}

export function ChecksPanel({ checks, compact = false }) {
  const groups = ['input', 'accounting', 'assumption'].map((c) => [c, checks.filter((k) => k.category === c)]).filter(([, l]) => l.length);
  return <div className="space-y-5" data-testid="checks-panel">
    {groups.map(([cat, list]) => <div key={cat}>
      {!compact && <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{CATEGORY[cat]}</p>}
      <ul className="space-y-2">
        {list.map((c) => <li key={c.key} className={`flex items-start gap-3 rounded-md border px-3 py-2 ${STYLE[c.status].cls}`} data-testid={`check-${c.key}`}>
          <StatusBadge status={c.status} />
          <div className="min-w-0"><p className="text-sm font-medium">{c.label}</p>{!compact && <p className="text-xs opacity-90">{c.detail}</p>}</div>
        </li>)}
      </ul>
    </div>)}
    <p className="text-xs text-muted-foreground">“PASS” means the statements reconcile arithmetically. It does not mean the forecast is guaranteed or that the assumptions are right.</p>
  </div>;
}
